module.exports = __webpack_public_path__ + "img/black-week-5-estrelas.a66d7a16.webp";